import { useMemo } from 'react';
import { useRequestController } from '../../Home/hooks/useRequestController.ts';
import { SKILL_LINKAGES_CACHE_KEY_PREFIX } from '../constants/skillDetail';
import type { IGetSkillLinkagesResponse } from '../types/skillDetail';

/**
 * 获取 Skill 联动案例列表
 * @param skillId - Skill 唯一标识
 * @param enabled - 是否发起请求
 */
export const useSkillLinkagesData = (skillId: string, enabled: boolean) => {
  const query = useMemo(
    () => ({ skill_id: skillId, all: 1 }),
    [skillId],
  );

  const { data, loading, error, refresh } = useRequestController({
    method: 'GET',
    url: '/api/v1/util/skills/linkages/list',
    cacheKey: skillId ? `${SKILL_LINKAGES_CACHE_KEY_PREFIX}${skillId}` : undefined,
    refreshDeps: query,
    ready: enabled && Boolean(skillId),
    cacheTime: 1800000,
    staleTime: 1800000,
  });

  const linkages = useMemo(
    () => (data as IGetSkillLinkagesResponse | undefined)?.list ?? [],
    [data],
  );

  return {
    linkages,
    loading,
    error,
    refreshLinkages: refresh,
  };
};
